/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Menu_SettingsInputs */

const he_auth_menu_settings = /** @type {(inputs: Auth_Menu_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הגדרות`)
};

const en_auth_menu_settings = /** @type {(inputs: Auth_Menu_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Auth_Menu_SettingsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_menu_settings = /** @type {((inputs?: Auth_Menu_SettingsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Menu_SettingsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_menu_settings(inputs)
	return en_auth_menu_settings(inputs)
});